import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-background-contrast text-text-inverse mt-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div className="md:col-span-2">
            <h3 className="text-xl font-heading font-bold mb-4">Precision Peptides AU</h3>
            <p className="text-slate-400 text-sm leading-relaxed mb-4">
              High-purity research peptides with verified Certificates of Analysis.
              Precision-tested compounds for laboratory use only.
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold mb-4">Navigation</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/shop" className="text-slate-400 hover:text-white transition-colors">
                  Shop Products
                </Link>
              </li>
              <li>
                <Link to="/quality" className="text-slate-400 hover:text-white transition-colors">
                  Quality & Testing
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-slate-400 hover:text-white transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-slate-400 hover:text-white transition-colors">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-slate-400 hover:text-white transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold mb-4">Admin</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/admin" className="text-slate-400 hover:text-white transition-colors">
                  Admin Panel
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-slate-700">
          <div className="bg-slate-800 border border-slate-700 rounded-lg p-6">
            <p className="text-sm font-medium text-center text-slate-300">
              <strong>IMPORTANT DISCLAIMER:</strong> All products are strictly for research and laboratory use only. Not for human consumption, veterinary use, or clinical application. Not intended to diagnose, treat, cure, or prevent any disease.
            </p>
          </div>
          <p className="text-center text-slate-500 text-sm mt-6">
            © {new Date().getFullYear()} Precision Peptides AU. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
